import React from 'react';
import {
    Grid,
    Paper,
    Badge,
    Avatar,
    Chip
} from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Logger } from '@apricityhealth/web-common-lib/utils/Logger';
import { Link } from 'react-router-dom';

const log = new Logger();
export class ActionButton extends React.Component {
    constructor(props) {
        super(props);

        if ( props.icon === undefined ) throw new Error("icon property required.");
        if ( props.label === undefined ) throw new Error("label property required.");
        // if ( props.label2 === undefined ) throw new Error("label2 property required.");
        if ( props.to === undefined && props.onClick === undefined ) throw new Error("to or onClick property required");

        this.state = {
            badge: props.badge || null,
            disabled: props.disabled || false
        }
    }

    componentDidUpdate(oldProps) {
        if ( oldProps.badge !== this.props.badge ) {
            this.setState({badge: this.props.badge || null});
        }
        if ( oldProps.disabled !== this.props.disabled ) {
            this.setState({disabled: this.props.disabled});
        }
    }

    render() {
        const { badge, disabled } = this.state;
        const { backgroundColor, disabledBackgroundColor, textColor, color, appContext: { theme } } = this.props;

        let paperStyle = JSON.parse(JSON.stringify(styles.paper));
        paperStyle.background = disabled ? (disabledBackgroundColor || theme.actionButton.disabledBackgroundColor) : (backgroundColor || theme.actionButton.backgroundColor);
            //paperStyle.background = this.props.alreadySelected ? '#dddddd' : '#ffffff';

        const icon = React.cloneElement( this.props.icon, {fontSize: 'small', style: {fill: (disabled || this.props.alreadySelected) ? theme.actionButton.disabledIconColor : color}});
        if (( disabled ) || ( this.props.alreadySelected )) {
            return <Grid id={this.props.id} item xs={12} sm={4} style={styles.actionButton}>
                <div style={{ textDecoration: 'none' }}>
                    <Paper style={paperStyle}>
                        <div style={{ margin: 11, float: 'left' }}>
                            <Badge style={{ right: 5, top: 5 }} color='secondary' overlap="circular" badgeContent={badge}>
                                <Avatar style={{ right: -5, top: -5, width: 35, height: 35, border: `2px solid ${color}`, backgroundColor }}>
                                    {icon}
                                </Avatar>
                            </Badge>
                        </div>
                        <div style={{ marginTop:12, float: 'left', overflow: 'clip' }}>
                            <div style={{fontSize: 18, marginBottom: 0, paddingBottom: 0 }}>{this.props.label}</div>
                            {/* All buttons should have a secondary description -desc */}
                            <div style={{fontSize: 12, marginTop: 0, paddingTop: 0 }}>{this.props.label2}</div>
                        </div>
                    </Paper>
                </div>
                {this.props.dialog}
            </Grid>;
        }
        else {
            return <Grid id={this.props.id} item xs={12} sm={4} style={styles.actionButton}>
                <Link disabled={disabled} to={this.props.to} onClick={(e) => {
                    log.metric( { EventName: "PatientAction", Action: this.props.metric || this.props.id, count: 1 } );
                    if ( this.props.onClick )
                        this.props.onClick(e);
                }} style={{ textDecoration: 'none' }}>
                    <Paper variant="outlined" elevation={1} style={paperStyle}>
                        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <div style={{ margin: 11 }}>
                                <Badge style={{ right: 5, top: 5 }} color='secondary' overlap="circular" badgeContent={badge}>
                                    <Avatar style={{ right: -5, top: -5, width: 35, height: 35, border: `2px solid ${color}`, backgroundColor: backgroundColor || '#ffffff' }}>
                                        {icon}
                                    </Avatar>
                                </Badge>
                            </div>
                            <div>
                                <div style={{fontSize: 18, marginBottom: 0, paddingBottom: 0, color: textColor }}>{this.props.label}</div>
                                {/* All buttons should have a secondary description -desc */}
                                <div style={{fontSize: 12, marginTop: 0, paddingTop: 0, fontStyle: 'italic', color: textColor }}>{this.props.label2}</div>
                            </div>
                            {this.props.chip && <div style={{ marginLeft: 'auto', marginRight: this.props.chevron ? 0 : 10, display: 'flex', alignItems: 'center' }}>
                                <Chip size='small' label={this.props.chip} style={{ backgroundColor: color, color: '#ffffff', fontWeight: 600 }} />
                            </div>}
                            {this.props.chevron && <div style={{ marginLeft: this.props.chip ? 6 : 'auto', marginRight: 10, display: 'flex', alignItems: 'center' }}>
                                <NavigateNextIcon style={{ color: textColor || '#888' }} />
                            </div>}
                        </div>
                    </Paper>
                </Link>
                {this.props.dialog}
            </Grid>;
        }
    }
}

const styles = {
    actionButton: {
        width: 350,
        minWidth: 340,
    },
    paper: {
        overflow: 'hidden',
        marginLeft: 15,
        marginRight: 15,
        marginTop: 5,
        marginBottom: 5,
        height: 65,
        textAlign: 'left',
        alignItems: 'center',
    }
};

export default ActionButton;
